import { z } from "zod";
import { ProductItemSchema } from "../product/product-item";

export const BillingOrderProductItemSchema = z.object({
  Id: z.string(),
  BaseAmount: z.number().optional(),
  ExtendedAmount: z.number().optional(),
  IsCopied: z.boolean().optional(),
  IsPriceOverridden: z.boolean().optional(),
  IsProductOverridden: z.boolean().optional(),
  LineItemNumber: z.number().optional(),
  ManualDiscountAmount: z.number().optional(),
  msdyn_IncludeExpense: z.boolean().optional(),
  msdyn_IncludeFee: z.boolean().optional(),
  msdyn_IncludeMaterial: z.boolean().optional(),
  msdyn_IncludeTime: z.boolean().optional(),
  PricePerUnit: z.number().optional(),
  PricingErrorCode: z.number().optional(),
  ProductName: z.string().optional(),
  ProductNumber: z.string().optional(),
  ProductTypeCode: z.number().optional(),
  PropertyConfigurationStatus: z.number().optional(),
  Quantity: z.number().optional(),
  SalesOrderDetailName: z.string().optional(),
  SalesOrderIsPriceLocked: z.boolean().optional(),
  SkipPriceCalculation: z.number().optional(),
  CurrencyId: z.string().optional(),
  UnitOfMeasureId: z.string().optional(),
  SalesOrderId: z.string().optional(),
  QuoteDetailId: z.string().optional(),
  ProductId: z.string().optional(),
  Product: ProductItemSchema,
});

export type BillingOrderProductItemType = z.infer<
  typeof BillingOrderProductItemSchema
>;
